import { shareholderInvestorControllerGetInvestorDealDocumentsOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { useQuery } from '@tanstack/react-query';

/**
 * DC-494: library documents a deal admin has opted in to this investor's portal. The endpoint
 * spans every deal the caller invests in and takes no investor id, so these belong to the
 * all-companies view of the documents grid rather than a per-investment one.
 */
export const useDealDocuments = ({ enabled }: { enabled: boolean }) => {
	const query = useQuery({
		...shareholderInvestorControllerGetInvestorDealDocumentsOptions(),
		enabled,
	});

	return {
		documents: query.data ?? [],
		isLoading: query.isLoading,
		isError: query.isError,
	};
};
